import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Main from './main';
import Footer from "./footer";
import Links from "./Links";
import "./main.css";
import TawkToWidget from './Tawkto';
import Navbar from './Navbar';

function AppContent() {
  const location = useLocation();

  return (
    <>
      <Routes>
        <Route path="/" element={<Links />} />
        <Route path="/main" element={<Main />} />
      </Routes>

      {}
      {location.pathname !== "/" && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="div">
      <Router>
          <Navbar/>
        <AppContent />
        <TawkToWidget />
      
      </Router>
    </div>
  );
}

export default App;
